/* @ts-ignore */
import * as Types from '../generated/graphql.g';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: TypedDocumentString<unknown, unknown>, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ResourceFragment = { __typename: 'ResourceType', id: string, createdAt: string, updatedAt: string, vendorName?: string | null, productName?: string | null, vendorDomainName?: string | null, productDomainName?: string | null, vendorDescription?: string | null, productDescription?: string | null, key?: string | null, signedLogoUrl?: string | null, mspVitalityScore: number, isForConsumers: boolean, isSaas: boolean, isVisible: boolean, isPrimaryResource: boolean, nonPrimaryResourcesCount?: number | null, category?: { __typename: 'ResourceCategoryType', id: string, name: string, parent?: { __typename: 'ResourceCategoryType', id: string, name: string } | null } | null, resourceGroup?: { __typename: 'ResourceGroupType', id: string } | null };

export type ResourcesQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  vendorName_Icontains?: Types.InputMaybe<Types.Scalars['String']['input']>;
  productName_Icontains?: Types.InputMaybe<Types.Scalars['String']['input']>;
  productDomainName_Icontains?: Types.InputMaybe<Types.Scalars['String']['input']>;
  vendorDomainName_Icontains?: Types.InputMaybe<Types.Scalars['String']['input']>;
  key?: Types.InputMaybe<Types.Scalars['String']['input']>;
  mspVitalityScore_Gte?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  mspVitalityScore_Lte?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  isForConsumers?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  isSaas?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  isVisible?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  isPrimaryResource?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  parentCategoryId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  orderBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ResourcesQuery = { __typename: 'Query', resources?: { __typename: 'ResourceTypeConnection', totalCount?: number | null, edges: Array<{ __typename: 'ResourceTypeEdge', node?: { __typename: 'ResourceType', id: string, createdAt: string, updatedAt: string, vendorName?: string | null, productName?: string | null, vendorDomainName?: string | null, productDomainName?: string | null, vendorDescription?: string | null, productDescription?: string | null, key?: string | null, signedLogoUrl?: string | null, mspVitalityScore: number, isForConsumers: boolean, isSaas: boolean, isVisible: boolean, isPrimaryResource: boolean, nonPrimaryResourcesCount?: number | null, category?: { __typename: 'ResourceCategoryType', id: string, name: string, parent?: { __typename: 'ResourceCategoryType', id: string, name: string } | null } | null, resourceGroup?: { __typename: 'ResourceGroupType', id: string } | null } | null } | null>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type ResourceQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  key?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ResourceQuery = { __typename: 'Query', resource?: { __typename: 'ResourceType', id: string, createdAt: string, updatedAt: string, vendorName?: string | null, productName?: string | null, vendorDomainName?: string | null, productDomainName?: string | null, vendorDescription?: string | null, productDescription?: string | null, key?: string | null, signedLogoUrl?: string | null, mspVitalityScore: number, isForConsumers: boolean, isSaas: boolean, isVisible: boolean, isPrimaryResource: boolean, nonPrimaryResourcesCount?: number | null, category?: { __typename: 'ResourceCategoryType', id: string, name: string, parent?: { __typename: 'ResourceCategoryType', id: string, name: string } | null } | null, resourceGroup?: { __typename: 'ResourceGroupType', id: string } | null } | null };

export type ResourcesByGroupQueryVariables = Types.Exact<{
  resourceGroupId: Types.Scalars['ID']['input'];
}>;


export type ResourcesByGroupQuery = { __typename: 'Query', resourceGroup?: { __typename: 'ResourceGroupType', id: string, resources: { __typename: 'ResourceTypeConnection', edges: Array<{ __typename: 'ResourceTypeEdge', node?: { __typename: 'ResourceType', id: string, createdAt: string, updatedAt: string, vendorName?: string | null, productName?: string | null, vendorDomainName?: string | null, productDomainName?: string | null, vendorDescription?: string | null, productDescription?: string | null, key?: string | null, signedLogoUrl?: string | null, mspVitalityScore: number, isForConsumers: boolean, isSaas: boolean, isVisible: boolean, isPrimaryResource: boolean, nonPrimaryResourcesCount?: number | null, category?: { __typename: 'ResourceCategoryType', id: string, name: string, parent?: { __typename: 'ResourceCategoryType', id: string, name: string } | null } | null, resourceGroup?: { __typename: 'ResourceGroupType', id: string } | null } | null } | null> } } | null };


export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const ResourceFragmentDoc = new TypedDocumentString(`
    fragment Resource on ResourceType {
  id
  createdAt
  updatedAt
  vendorName
  productName
  vendorDomainName
  productDomainName
  vendorDescription
  productDescription
  key
  signedLogoUrl
  mspVitalityScore
  isForConsumers
  isSaas
  isVisible
  isPrimaryResource
  nonPrimaryResourcesCount
  category {
    id
    name
    parent {
      id
      name
    }
  }
  resourceGroup {
    id
  }
}
    `, {"fragmentName":"Resource"});
export const ResourcesDocument = new TypedDocumentString(`
    query Resources($after: String, $before: String, $first: Int, $last: Int, $offset: Int, $search: String, $vendorName_Icontains: String, $productName_Icontains: String, $productDomainName_Icontains: String, $vendorDomainName_Icontains: String, $key: String, $mspVitalityScore_Gte: Int, $mspVitalityScore_Lte: Int, $isForConsumers: Boolean, $isSaas: Boolean, $isVisible: Boolean, $isPrimaryResource: Boolean, $parentCategoryId: UUID, $orderBy: String) {
  resources(
    after: $after
    before: $before
    first: $first
    last: $last
    offset: $offset
    search: $search
    vendorName_Icontains: $vendorName_Icontains
    productName_Icontains: $productName_Icontains
    productDomainName_Icontains: $productDomainName_Icontains
    vendorDomainName_Icontains: $vendorDomainName_Icontains
    key: $key
    mspVitalityScore_Gte: $mspVitalityScore_Gte
    mspVitalityScore_Lte: $mspVitalityScore_Lte
    isForConsumers: $isForConsumers
    isSaas: $isSaas
    isVisible: $isVisible
    isPrimaryResource: $isPrimaryResource
    parentCategoryId: $parentCategoryId
    orderBy: $orderBy
  ) {
    edges {
      node {
        ...Resource
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment Resource on ResourceType {
  id
  createdAt
  updatedAt
  vendorName
  productName
  vendorDomainName
  productDomainName
  vendorDescription
  productDescription
  key
  signedLogoUrl
  mspVitalityScore
  isForConsumers
  isSaas
  isVisible
  isPrimaryResource
  nonPrimaryResourcesCount
  category {
    id
    name
    parent {
      id
      name
    }
  }
  resourceGroup {
    id
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);

export const useResourcesQuery = <
      TData = ResourcesQuery,
      TError = unknown
    >(
      variables?: ResourcesQueryVariables,
      options?: Omit<UseQueryOptions<ResourcesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ResourcesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ResourcesQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['Resources'] : ['Resources', variables],
    queryFn: fetcher<ResourcesQuery, ResourcesQueryVariables>(ResourcesDocument, variables),
    ...options
  }
    )};

useResourcesQuery.getKey = (variables?: ResourcesQueryVariables) => variables === undefined ? ['Resources'] : ['Resources', variables];

export const useInfiniteResourcesQuery = <
      TData = InfiniteData<ResourcesQuery>,
      TError = unknown
    >(
      variables: ResourcesQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ResourcesQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ResourcesQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ResourcesQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['Resources.infinite'] : ['Resources.infinite', variables],
      queryFn: (metaData) => fetcher<ResourcesQuery, ResourcesQueryVariables>(ResourcesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteResourcesQuery.getKey = (variables?: ResourcesQueryVariables) => variables === undefined ? ['Resources.infinite'] : ['Resources.infinite', variables];


useResourcesQuery.fetcher = (variables?: ResourcesQueryVariables) => fetcher<ResourcesQuery, ResourcesQueryVariables>(ResourcesDocument, variables);

export const ResourceDocument = new TypedDocumentString(`
    query Resource($id: UUID, $key: String) {
  resource(id: $id, key: $key) {
    ...Resource
  }
}
    fragment Resource on ResourceType {
  id
  createdAt
  updatedAt
  vendorName
  productName
  vendorDomainName
  productDomainName
  vendorDescription
  productDescription
  key
  signedLogoUrl
  mspVitalityScore
  isForConsumers
  isSaas
  isVisible
  isPrimaryResource
  nonPrimaryResourcesCount
  category {
    id
    name
    parent {
      id
      name
    }
  }
  resourceGroup {
    id
  }
}`);

export const useResourceQuery = <
      TData = ResourceQuery,
      TError = unknown
    >(
      variables?: ResourceQueryVariables,
      options?: Omit<UseQueryOptions<ResourceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ResourceQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ResourceQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['Resource'] : ['Resource', variables],
    queryFn: fetcher<ResourceQuery, ResourceQueryVariables>(ResourceDocument, variables),
    ...options
  }
    )};

useResourceQuery.getKey = (variables?: ResourceQueryVariables) => variables === undefined ? ['Resource'] : ['Resource', variables];

export const useInfiniteResourceQuery = <
      TData = InfiniteData<ResourceQuery>,
      TError = unknown
    >(
      variables: ResourceQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ResourceQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ResourceQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ResourceQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['Resource.infinite'] : ['Resource.infinite', variables],
      queryFn: (metaData) => fetcher<ResourceQuery, ResourceQueryVariables>(ResourceDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteResourceQuery.getKey = (variables?: ResourceQueryVariables) => variables === undefined ? ['Resource.infinite'] : ['Resource.infinite', variables];


useResourceQuery.fetcher = (variables?: ResourceQueryVariables) => fetcher<ResourceQuery, ResourceQueryVariables>(ResourceDocument, variables);

export const ResourcesByGroupDocument = new TypedDocumentString(`
    query ResourcesByGroup($resourceGroupId: ID!) {
  resourceGroup(id: $resourceGroupId) {
    id
    resources {
      edges {
        node {
          ...Resource
        }
      }
    }
  }
}
    fragment Resource on ResourceType {
  id
  createdAt
  updatedAt
  vendorName
  productName
  vendorDomainName
  productDomainName
  vendorDescription
  productDescription
  key
  signedLogoUrl
  mspVitalityScore
  isForConsumers
  isSaas
  isVisible
  isPrimaryResource
  nonPrimaryResourcesCount
  category {
    id
    name
    parent {
      id
      name
    }
  }
  resourceGroup {
    id
  }
}`);

export const useResourcesByGroupQuery = <
      TData = ResourcesByGroupQuery,
      TError = unknown
    >(
      variables: ResourcesByGroupQueryVariables,
      options?: Omit<UseQueryOptions<ResourcesByGroupQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ResourcesByGroupQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ResourcesByGroupQuery, TError, TData>(
      {
    queryKey: ['ResourcesByGroup', variables],
    queryFn: fetcher<ResourcesByGroupQuery, ResourcesByGroupQueryVariables>(ResourcesByGroupDocument, variables),
    ...options
  }
    )};

useResourcesByGroupQuery.getKey = (variables: ResourcesByGroupQueryVariables) => ['ResourcesByGroup', variables];

export const useInfiniteResourcesByGroupQuery = <
      TData = InfiniteData<ResourcesByGroupQuery>,
      TError = unknown
    >(
      variables: ResourcesByGroupQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ResourcesByGroupQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ResourcesByGroupQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ResourcesByGroupQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ResourcesByGroup.infinite', variables],
      queryFn: (metaData) => fetcher<ResourcesByGroupQuery, ResourcesByGroupQueryVariables>(ResourcesByGroupDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteResourcesByGroupQuery.getKey = (variables: ResourcesByGroupQueryVariables) => ['ResourcesByGroup.infinite', variables];


useResourcesByGroupQuery.fetcher = (variables: ResourcesByGroupQueryVariables) => fetcher<ResourcesByGroupQuery, ResourcesByGroupQueryVariables>(ResourcesByGroupDocument, variables);
